import { StoreApi, UseBoundStore, create } from 'zustand';

interface FilterBarOpenState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

type FilterBarStore = UseBoundStore<StoreApi<FilterBarOpenState>>;

const stores = new Map<string, FilterBarStore>();

const createFilterBarStore = () =>
  create<FilterBarOpenState>((set) => ({
    open: false,
    setOpen: (open) => set({ open }),
  }));

export const useFilterBarOpen = (id: string) => {
  if (!stores.has(id)) {
    stores.set(id, createFilterBarStore());
  }
  // Map.get() is guaranteed to return FilterBarStore due to the check above
  return (stores.get(id) as FilterBarStore)();
};
